const getBookings = (state) => state.myTrips.bookings;
const getLoading = (state) => state.myTrips.loading;
const getCurrentPage = (state) => state.myTrips.currentPage;
const getPageLoading = (state) => state.myTrips.pageLoading;
const getStatusFilter = (state) => state.myTrips.statusFilter;

export { getBookings, getLoading, getCurrentPage, getPageLoading, getStatusFilter };
